import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import { Container, Paper, Box, Typography, Button, Alert, Chip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InvoicePDF from './invoice/InvoicePDF';
// import CreditNotePDF from './CreditNotePDF'; // <--- Importamos el PDF de Nota de Crédito

export default function InvoiceViewer({ documents }) {
  const location = useLocation();
  const history = useHistory();
  const document =  location.state.documents;

  const documentData = document;

  if (!documentData) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Alert severity="error">
          Documento no encontrado. Es posible que haya sido eliminado o el enlace sea incorrecto.
        </Alert>
        <Button sx={{ mt: 2 }} startIcon={<ArrowBackIcon />} variant="outlined" onClick={() => history.push('/invoices')}>
          Volver al listado
        </Button>
      </Container>
    );
  }

  // Decidimos qué componente PDF usar según el tipo de documento
  // const PdfComponent = documentData.docType === 'NOTA_DE_CREDITO' ? CreditNotePDF : InvoicePDF;
  const PdfComponent = InvoicePDF;

  // Color del encabezado según el tipo de documento
  const headerColor = documentData.docType === 'NOTA_DE_CREDITO' ? 'error' : 'primary';

  return (
    <Container maxWidth="lg" sx={{ mt: 2, mb: 2, display: 'flex', flexDirection: 'column', height: '90vh' }}>
      <Paper sx={{ p: 2, flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        
        {/* Cabecera del Visor */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Button startIcon={<ArrowBackIcon />} variant="outlined" onClick={() => history.push('/invoices')}>
              Volver
            </Button>
            <Typography variant="h6" fontWeight="bold" color={headerColor}>
              Viendo: {documentData.documentType === '03' ? 'BOLETA' : 'FACTURA'}  {`${documentData.serie} - ${documentData.correlative}`}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Cliente: {documentData.userName}
            </Typography>
            <Chip 
              label={documentData.statusSunat} 
              color={documentData.statusSunat === 'P ' ? 'success' : documentData.statusSunat === 'ANULADA' ? 'error' : 'warning'} 
              size="small" 
            />
          </Box>
        </Box>

        {/* Visor de PDF incrustado dinámico */}
        <PDFViewer 
          style={{ width: '100%', height: '100%', border: 'none' }}
          showToolbar={true}
        >
          <PdfComponent data={documentData} />
        </PDFViewer>

      </Paper>
    </Container>
  );
}